import React, { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import ModalB from 'components/Modal/ModalB';
import BuildChildren from 'utils/BuildChildren';
import classes from './PackageTabCModal.module.scss';

const PackageTabCModal = (props) => {
  const {
    header,
    children,
  } = props;

  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className={classes.container}>
      <button
        onClick={() => setShowPopup(!showPopup)}
        className={classes.headerButton}
        aria-label={header}
        type='button'
      >
        <h4
          className={classes.header}
          dangerouslySetInnerHTML={{ __html: header }}
        />
      </button>
      <Modal
        isOpen={showPopup}
        onRequestClose={() => setShowPopup(!showPopup)}
        shouldCloseOnOverlayClick
        ariaHideApp={false}
        className={classes.modal}
        overlayClassName={classes.overlayModal}
        closeTimeoutMS={250}
      >
        <ModalB hideModal={() => setShowPopup(!showPopup)} containerClass={classes.width100}>
          <div
            className={classes.modalHeader}
            dangerouslySetInnerHTML={{ __html: header }}
          />
          {BuildChildren(children)}
        </ModalB>
      </Modal>
    </div>
  );
};

PackageTabCModal.propTypes = {
  header: PropTypes.string,
  children: PropTypes.object,
};

export default PackageTabCModal;
